import { HomescreenSettings } from './settings.models';

/**
 * LEGACY-HOMESCREEN-V1
 *
 * Clients released before the homescreen became a position map stored it as an ordered
 * array of tile ids. The backend flags those payloads with `version: -1`.
 *
 * Deliberately self-contained, so removing the format means deleting this file plus its
 * single call site — grep for `LEGACY-HOMESCREEN-V1` to find both. That is safe once no
 * installed client can still be holding the array format.
 *
 * @deprecated Only reachable for `version: -1` responses.
 */

/** Version the backend reports for the pre-position-map payload. */
export const LEGACY_HOMESCREEN_VERSION = -1;

export const isLegacyHomescreen = (version: number): boolean =>
  version === LEGACY_HOMESCREEN_VERSION;

/**
 * Turns the ordered array into the current position map: the array index becomes the
 * position. Accepts both shapes that occur in the wild — bare id strings and objects
 * carrying an `id` — and returns null for anything it cannot read, which leaves the
 * locally stored homescreen untouched rather than emptying it.
 */
export const convertLegacyHomescreen = (value: unknown): HomescreenSettings | null => {
  let parsed = value;
  if (typeof parsed === 'string') {
    try {
      parsed = JSON.parse(parsed);
    } catch {
      return null;
    }
  }
  if (!Array.isArray(parsed)) return null;

  const homescreen: HomescreenSettings = {};
  parsed.forEach((entry: unknown, index: number) => {
    const id = legacyTileId(entry);
    if (id !== null) homescreen[id] = { position: index };
  });

  return Object.keys(homescreen).length > 0 ? homescreen : null;
};

const legacyTileId = (entry: unknown): string | null => {
  if (typeof entry === 'string') return entry;
  if (typeof entry === 'object' && entry !== null && 'id' in entry) {
    const { id } = entry as { id: unknown };
    if (typeof id === 'string') return id;
    if (typeof id === 'number') return String(id);
  }
  return null;
};
